import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import FilePreview from './FilePreview'
import ConditionalWrapper from '../hoc/ConditionalWrapper'
import ButtonClose from '../../features/components/Buttons/ButtonClose'
import ProgressBar from '../ProgressBar'

import useGetAccessibleUrl from '../../features/hooks/useGetAccessibleUrl'

import useStyles from './styles'

function FileDetailsPreview({
  className,
  removeFile,
  fileName,
  fileDescription,
  fileFormat,
  filePreviewType,
  fileUrl,
  openPreviewOnClick,
  FileIcon,
  iconColor,
  isFileLoading,
  allowDelete,
  fileUploadProgress
}) {
  const classes = useStyles()

  const { isAccessibleUrlLoading, handleFileDownloading } = useGetAccessibleUrl()

  const handleFileDownload = useCallback(() => {
    handleFileDownloading(fileUrl)
  }, [fileUrl, handleFileDownloading])

  return (
    <div className={classnames(className, classes.fileDetails)}>
      <div className={classes.uploadedContainer}>
        <ConditionalWrapper
          wrapper={children => (
            <div className={classes.clickablePreview} onClick={handleFileDownload}>
              {children}
            </div>
          )}
          condition={openPreviewOnClick}
        >
          <FilePreview
            fileName={fileName}
            fileDescription={fileDescription}
            fileFormat={fileFormat}
            filePreviewType={filePreviewType}
            fileUrl={fileUrl}
            FileIcon={FileIcon}
            iconColor={iconColor}
            isLoading={isAccessibleUrlLoading}
          />
        </ConditionalWrapper>
        {allowDelete && <ButtonClose className={classes.deleteBtn} onClick={removeFile} />}
      </div>
      {isFileLoading && <ProgressBar className={classes.progressBar} value={fileUploadProgress || 0} />}
    </div>
  )
}

FileDetailsPreview.propTypes = {
  removeFile: PropTypes.func,
  FileIcon: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  iconColor: PropTypes.string,
  fileName: PropTypes.string,
  fileDescription: PropTypes.string,
  fileFormat: PropTypes.string,
  filePreviewType: PropTypes.string,
  fileUrl: PropTypes.string,
  isFileLoading: PropTypes.bool,
  allowDelete: PropTypes.bool,
  openPreviewOnClick: PropTypes.bool,
  fileUploadProgress: PropTypes.number
}

export default FileDetailsPreview
